import { Link } from "react-router-dom";
import { Phone, FileText } from "lucide-react";
import { COMPANY } from "@/lib/constants";

export default function StickyCTA() {
  return (
    <div className="lg:hidden fixed bottom-0 inset-x-0 z-50 bg-card border-t border-border grid grid-cols-2 shadow-[0_-4px_20px_rgba(0,0,0,0.08)]" data-testid="sticky-cta">
      <a href={`tel:${COMPANY.phoneRaw}`} className="flex items-center justify-center gap-2 py-4 font-bold text-secondary" data-testid="sticky-call">
        <Phone className="h-5 w-5 text-primary" /> Call Now
      </a>
      <Link to="/contact" className="flex items-center justify-center gap-2 py-4 font-bold bg-primary text-primary-foreground" data-testid="sticky-quote">
        <FileText className="h-5 w-5" /> Free Quote
      </Link>
    </div>
  );
}
